module.exports = __webpack_public_path__ + "static/media/kodfit_logo_small.b9ccb11f.svg";